const mainSearch = () => {

  // Set custom variables
  const minSearchChars = 1; // Minimum number of characters to perform search
  const keystrokeDebounceTime = 200; // Milliseconds after search keystroke before search request is made
  const maxSearchResultsToDisplay = 8; // Max number of results to display
  const resultsSequentialDelay = 25; // Milliseconds between each search result appearing

  // Search elements
  let searchForms = document.querySelectorAll('header form[action="/search"]');
  const resultsOverlay = document.getElementById('search-results');
  const searchResultsPanel = resultsOverlay.querySelector('.results');
  const searchEmptyResultsPanel = resultsOverlay.querySelector('.results-empty');

  // Search states
  let searchSubmitReady = false;
  //let searchController = null;
  let debounceTimeout = null;
  let searchResultsHeading = null;


  // Function to get search URL with term
  const getSearchURL = (term) => `${window.location.origin}/search?type=product&q=${encodeURIComponent(term)}*`;


  // Fetch Search term
  const fetchSearchTerm = (term, searchResultsHeading) => {
    let searchEndpoint = `${getSearchURL(term)}&view=json`; // as JSON
    /*
    // Abort the previous search request if it exists
    if (searchController) {
      searchController.abort();
    }
    // Create a new AbortController instance for the new request
    searchController = new AbortController();
    let signal = searchController.signal;
    fetch(searchEndpoint, { signal })
    */
    fetch(searchEndpoint)
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();  // Parse the response as JSON
    })
    .then(data => {
      //console.log(data);  // Output the JSON data to the console

      searchSubmitReady = true; // Allow search submit
      searchResultsPanel.innerHTML = ''; // Remove existing search content

      // If no results...
      if(data.results_count == 0) {
        // Check for matches in searchOther array
        let searchOtherMatch = checkSearchOther(term);
        if (searchOtherMatch == false) {
          // Check for matches in searchCustom array
          let searchCustomMatch = checkSearchCustom(term);
          if (searchCustomMatch == false) {
            // Show no results
            noSearchResults(term);
          }
        }
      }
      // Results!
      else {
        makeSearchResults(data, term, searchResultsHeading);
      }

    });
    /*
    .catch(error => {
      if (error.name === 'AbortError') {
          // Handle abort gracefully; no need to log as error
          console.log('Fetch request was aborted.');
      } else {
          // Log other types of errors
          console.error('Fetch error:', error);
      }
    });
    */
  } // fetchSearchTerm()




  const makeSearchResults = (data, term, heading) => {

    if(heading) { // Append heading if provided
      searchResultsPanel.append(heading);
    }

    let resultCount = 0;
    let availableResultCount = 0;
    let hiddenCount = 0;

    for(var i = 0; i < data.results.length; i++) {
      let item = data.results[i];
      resultCount += 1;
      // Don't apply if product has hide tag OR template suffix is 'unavailable'
      if (item.show === 'false') {
        hiddenCount += 1;
      } else {
        availableResultCount += 1;
        // Cap displayed results
        if(availableResultCount > maxSearchResultsToDisplay) {
          continue; // next loop iteration
        }

        // Title
        let title = item.title.replace('- ', "<span>") + '</span>';

        // Price
        let price;
        let saleClass = '';
        let comparePriceSpan = '';
        let firstVariantPrice = item.variants[0].price;
        let firstVariantCompareAtPrice = item.variants[0].compare_at_price;
        let usePriceRange = true;
        /*
        // Check for products that use price range
        for(var tag=0; tag<item.tags.length; tag++) {
          if (item.tags[tag] == 'style:brand:initial-letter' || 
              item.tags[tag] == 'customise:chain-size' || 
              item.tags[tag] == 'customise:stone-count' || 
              item.url.includes('chupi-gift-coin') || 
              item.url.includes('chupi-digital-gift-voucher')
          ) {
            usePriceRange = true;
          }
        }
        */
        // Exception products with different default variant
        if(item.tags.includes('customise:chain-size')) {
          for(var variant=0; variant<item.variants.length; variant++) {
            if (item.variants[variant].sku !== null) {
              if (item.variants[variant].sku.includes('SMALL') || item.variants[variant].sku.includes('S/M') || item.variants[variant].sku.includes('LARGE') || item.variants[variant].sku.includes('M/L')) {
                firstVariantPrice = item.variants[variant].price;
                firstVariantCompareAtPrice = item.variants[variant].compare_at_price;
                break;
              }
            }
          }
        } else if(item.tags.includes('customise:ears')) {
          for(var variant=0; variant<item.variants.length; variant++) {
            if (item.variants[variant].title.toLowerCase().includes('pair')) {
              firstVariantPrice = item.variants[variant].price;
              firstVariantCompareAtPrice = item.variants[variant].compare_at_price;
              break;
            }
          }
        }
        if (item.priceVaries) { // check for price range
          price = makeCurrency((firstVariantPrice/100).toFixed(2).replace('.00', ''), true);
          if (usePriceRange == true) { // check for price range product
            price = `From ${price}`;
          }
          if (firstVariantCompareAtPrice !== null) {
            saleClass = 'sale';
            comparePriceSpan = `<span>${makeCurrency((firstVariantCompareAtPrice/100).toFixed(2).replace('.00', ''), true)}</span>`;
          } else {
            saleClass = '';
          }
        } else {
          price = makeCurrency((item.price/100).toFixed(2).replace('.00', ''), true);
          // Check for compare-at-price
          if (item.compareAtPrice !== null) {
            saleClass = 'sale';
            comparePriceSpan = `<span>${makeCurrency((item.compareAtPrice/100).toFixed(2).replace('.00', ''), true)}</span>`;
          } else {
            saleClass = '';
          }
        }

        // Create and append search card
        let searchCard = document.createElement('a');
        searchCard.classList.add('grid-item', 'search-card', 'loading');
        searchCard.setAttribute('href', item.url);
        searchCard.innerHTML = `
          <img src="${item.thumbnail}" alt="${item.title}" width="200">
          <h3 class="title">${title}</h3>
          <span class="price ${saleClass}">
            ${price}
            ${comparePriceSpan}
          </span>`;
        searchResultsPanel.append(searchCard);

      }

    } // for each item

    // If there are available results, show them
    if (availableResultCount > 0) {
      // Display panel
      searchResultsPanel.classList.add('active');
      searchResultsPanel.classList.remove('loading');
      searchEmptyResultsPanel.classList.remove('active');
      // Sequentially show search cards
      let searchCards = searchResultsPanel.querySelectorAll('.search-card');
      searchCards.forEach((card,i) => {
        setTimeout(() => {
          card.classList.remove('loading');
        }, i * resultsSequentialDelay);
      });
      // If more than max results to show, append load-more link
      if(availableResultCount > maxSearchResultsToDisplay) {
        let loadMoreLink = document.createElement('a');
        loadMoreLink.classList.add('load-more');
        loadMoreLink.setAttribute('href', getSearchURL(term));
        loadMoreLink.innerText = 'More results';
        loadMoreLink.style.opacity = '0';
        searchResultsPanel.append(loadMoreLink);
        setTimeout(() => {
          loadMoreLink.style.opacity = '1';
        }, searchCards.length * resultsSequentialDelay);
      }
    }
    // Else all results are hidden, display 'no-results'
    else {
      noSearchResults(term);
    }

  } // makeSearchResults()



  const checkSearchOther = (term) => {
    let match = false;
    for(var i=0; i<searchOther.length; i++) {
      if(searchOther[i].terms.some(x => term.includes(x))) {
        if (searchOther[i].type == 'alternative') {
          searchResultsHeading = document.createElement('p');
          searchResultsHeading.innerHTML = `
            No results for <q class="search-term">${term}</q>
            <span> You might be interested in: <q class="new-term">${searchOther[i].newTerm}</q></span>
          `;
        } else {
          searchResultsHeading = null;
        }
        fetchSearchTerm(searchOther[i].newTerm, searchResultsHeading);
        match = true;
        break;
      }
    }
    return match;
  } // checkSearchOther()



  const checkSearchCustom = (term) => {
    let match = false;
    for(var i=0; i<searchCustom.length; i++) {
      if(searchCustom[i].terms.some(x => term.includes(x))) {
        searchResultsPanel.classList.add('active');
        searchResultsPanel.classList.remove('loading');
        searchEmptyResultsPanel.classList.remove('active');
        // Append heading
        searchResultsHeading = document.createElement('p');
        searchResultsHeading.innerHTML = 'Did you mean:';
        searchResultsPanel.append(searchResultsHeading);
        // Make card for each custom search suggestion
        searchCustom[i].suggestions.forEach(suggestion => {
          // Create and append custom search card
          let customSearchCard = document.createElement('a');
          customSearchCard.classList.add('grid-item', 'search-card');
          customSearchCard.setAttribute('href', suggestion.link);
          let imageElement = suggestion.image ? `<div class="image"><img class="object-cover" src="${suggestion.image}"></div>` : `<div class="image"></div>`;
          customSearchCard.innerHTML = `
            ${imageElement}
            <h3 class="title">${suggestion.title}</h3>
          `;
          searchResultsPanel.append(customSearchCard);
        });
        // setTimeout(() => { // Remove load more link if it persists from previous results load
        //   let loadMoreLink = searchResultsPanel.querySelector('.load-more');
        //   if(loadMoreLink) {
        //     loadMoreLink.remove();
        //   }
        // },100);
        match = true;
        break;
      }
    }
    return match;
  } // checkSearchCustom()



  const noSearchResults = (term) => {
    searchResultsPanel.classList.remove('active');
    searchEmptyResultsPanel.classList.add('active');
    searchEmptyResultsPanel.querySelector('q').innerText = term;
  } // noSearchResults()



  // Listen for user search input
  searchForms.forEach((searchForm) => {

    let input = searchForm.querySelector('input[name="q"]');
    let currentTerm = input.value.toLowerCase();

    // Type...
    input.addEventListener('keyup', () => {
      let term = input.value.toLowerCase();
      if (term.length >= minSearchChars) {
        if (term !== currentTerm) { // Only allow if term has changed
          resultsOverlay.classList.add('active'); // Open results overlay
          handleFixedElements('hide');
          searchSubmitReady = false; // Disable search submit
          // Use debouncing to only make request after a specified keystroke gap
          if (debounceTimeout) {
            clearTimeout(debounceTimeout);
          }
          debounceTimeout = setTimeout(() => {
            searchResultsPanel.classList.add('loading'); // Fade out existing panel
            fetchSearchTerm(term); // Fetch results
          }, keystrokeDebounceTime);
        }
      } else {
        resultsOverlay.classList.remove('active'); // Close results panel
        handleFixedElements('show');
      }
      currentTerm = term; // update current term to compare against next input term
    }); // keyup

    // Submit...
    searchForm.addEventListener('submit', function(e) {
      e.preventDefault();
      if (searchSubmitReady == true) { // Only allow submit when results check has run
        let loadMoreLink = searchResultsPanel.querySelector('.load-more');
        if(loadMoreLink) { // If load-more link, use its href
          window.location.href = loadMoreLink.getAttribute('href');
        } else {
          window.location.href = getSearchURL(input.value);
        }
      }
    });


  });

  // Close search overlay on click outside modal
  resultsOverlay.addEventListener('click', e => {
    if (!e.target.closest('.modal')){
      resultsOverlay.classList.remove('active'); // Close results panel
      handleFixedElements('show');
    }
  });


} // mainSearch()
mainSearch();



